import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["item", "position"];

  connect() {
    try {
      this.sortable = Sortable.create(this.element, {
        animation: 150,
        draggable: ".nested-form-wrapper",
        handle: '[data-action="sortable-steps#drag"]',
        onEnd: this.onEnd.bind(this),
        ghostClass: "sortable-ghost",
        dragClass: "sortable-drag",
      });
    } catch (error) {
      console.error("Error initializing SortableJS:", error);
    }
    this.updatePositions();
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  onEnd() {
    this.updatePositions();
  }

  updatePositions() {
    this.itemTargets.forEach((element, index) => {
      const positionInput = element.querySelector(
        '[data-sortable-steps-target="position"]',
      );
      if (positionInput) {
        positionInput.value = index + 1;
      }
    });
  }

  drag() {}
}
